<template>
	<div class="width-screen flex flex-warp align-center">
		<!-- 页面顶部搜索模块组件 -->
		<div class="float-left searchItemDiv" v-for="(item, index) in searchData" :key="index">
			<p class="searchItemTitle" v-text="item.label" v-if="item.type != 'checkbox'"></p>

			<!-- 普通文本输入框 -->
			<el-input class="searchItemInput" size="small" v-model="item.value" :placeholder="'请输入' + item.label"
				v-show="item.type == 'input'" clearable></el-input>
			<!-- 输入内容后自动搜索内容输入框 -->
			<el-autocomplete class="searchItemInput" v-model="item.values" value-key="label" :fetch-suggestions="querySearch" 
				:data-valuekey="item.valueKey" :data-labelkey="item.labelkey" :data-api="item.api" 
				@focus="getInputSelectType($event)" :placeholder="'请输入' + item.label" :trigger-on-focus="false"
				v-if="item.type == 'inputSelect'" @select="handleInputSelect(index,$event)" clearable @clear="clearAutocomplete(index)">
			</el-autocomplete>

			<!-- 下拉列表 -->
			<el-select class="searchItemInput" size="small" v-model="item.value" placeholder="请选择"
				v-show="item.type == 'select'" @change="changeSelect($event, item.name)">
				<el-option v-for="(selectItem, selectIndex) in item.options" :key="selectItem.value"
					:label="selectItem.label" :value="selectItem.value"></el-option>
			</el-select>
			<!-- 时间选择器（开始时间/结束时间） -->
			<el-date-picker class="searchItemInput" v-model="item.value" :type="item.type" size="small"
				:picker-options="pickerOptions" :value-format="item.valueFormat || 'YYYY-MM-DD HH:mm:ss'" :format="item.valueFormat || 'YYYY-MM-DD HH:mm:ss'" range-separator="至"
				start-placeholder="开始时间" end-placeholder="结束时间" v-if="item.type == 'datetimerange' || item.type == 'daterange'"
				@change="changeDateTimeRange" align="right"></el-date-picker>
			<!-- 多选框 -->
			<el-checkbox v-model="item.value" v-show="item.type == 'checkbox'">{{item.label}}</el-checkbox>
			<!-- 选择树 -->
			<el-input @click="searchTree(index)" @clear="clearSearchTree(index)" class="searchItemInput" size="small"
				v-model="item.valueText" :placeholder="'请选择' + item.label" v-show="item.type == 'tree'" clearable>
			</el-input>
			<!-- 级联选择组件 1、设置props可进行懒加载方式，2、设置options可以一次性加载完数据模式，设置valuesKey，接口需要的每一层的key值，这里传入数组的形式 -->
			<el-cascader class="searchItemCascader" v-model="item.value" :options="item.options" :props="cascaderProps" v-if="item.type == 'cascader'" clearable
				@change="changeCascaderSelect"></el-cascader>
		</div>

		<!-- 搜索按钮 -->
		<div class="searchBtn flex align-center justify-center" >
      <el-button type="primary" @click="resetBtnClick($event)">重&nbsp;置</el-button>
			<el-button type="primary" @click="searchBtnClick($event)">查&nbsp;询</el-button>
			<!-- 筛选按钮 -->
      <img :src="isShowList ? require('@/static/images/icon_pack_up.png') : require('@/static/images/icon_pack_down.png')" @click="cutList(isShowList)" alt="">

      <img :src="require('@/static/images/downloadBtn.png')" @click="exportClick()" alt="">
		</div>

    <div class="selectList" v-show="isShowList">
      <div class="dyOrderStatusDiv flex align-center">
        <span>抖店订单状态：</span>
        <ul class="dyOrderStatusList">
          <li v-for="(item, index) in searchList[0].value" :key="index" :class="(index == dyOrderIndex) ? 'active' : '' " @click="dyOrderClick(index, item.value)">{{item.key}}</li>
        </ul>
      </div>
      <div class="dyOrderStatusDiv flex align-center">
        <span>定制信息状态：</span>
        <ul class="dyOrderStatusList">
          <li v-for="(item, index) in searchList[1].value" :key="index" :class="(index == customInfoIndex) ? 'active' : '' " @click="customInfoClick(index, item.value)">{{item.key}}</li>
        </ul>
      </div>
      <div class="dyOrderStatusDiv flex align-center">
        <span>美印订单状态：</span>
        <ul class="dyOrderStatusList">
          <li v-for="(item, index) in searchList[2].value" :key="index" :class="(index == myOrderIndex) ? 'active' : '' " @click="myOrderClick(index, item.value)">{{item.key}}</li>
        </ul>
      </div>
      <div class="dyOrderStatusDiv flex align-center">
        <span>抖音售后状态：</span>
        <ul class="dyOrderStatusList">
          <li v-for="(item, index) in searchList[3].value" :key="index" :class="(index == refundStatusIndex) ? 'active' : '' " @click="refundStatusClick(index, item.value)">{{item.key}}</li>
        </ul>
      </div>
    </div>

		<basedialog :title="'选择' + dialogTitle" :dialogVisible="isShowTreeDialog" @dialogConfirm="treeDialogConfirm"
			@dialogClose="treeDialogClose" @dialogRightTopClose="treeDialogClose">
			<template #dialogbody>
				<div class="elFormTree" style="max-height: 200px; overflow-y: scroll;">
					<el-form ref="dialogForm" :rules="dialogFormRules" :model="dialogForm" label-width="200px"
						class="dialogForm">
						<el-form-item :label="dialogTitle + '名称:'" prop="menuName" class="flex align-center">
							<el-tree ref="dialogTree" :data="treeData" :props="treeProps" :load="loadTreeNode"
								:lazy="treeLazy" :show-checkbox="selectType == 'checkbox'" :node-key="treeNodeKey"
								:highlight-current="true">
							</el-tree>
						</el-form-item>
					</el-form>
				</div>
			</template>
		</basedialog>
	</div>
</template>

<script>
	import basedialog from "@/components/basedialog"
	export default {
		inject: ['$http', '$api', '$utils'],
		components: {
			basedialog,
		},
		props: ['searchData', 'cascaderProps', 'searchList', 'dyOrderIndex', 'customInfoIndex', 'myOrderIndex', 'refundStatusIndex'],

		data() {
			return {
				memberNo: "",
				isShowTreeDialog: false,
				dialogTitle: "",
				treeProps: {
					label: 'title',
					children: 'children',
					isLeaf: 'leaf'
				},
				treeApi: '',
				treeApiParam: {},
				treeData: [],
				selectType: 'checkbox', //当前选择树控件选择类型，single:单选  checkbox:多选
				treeNodeKey: 'key', //tree组件 node-key
				treeLazy: false, //是否懒加载
				clickSearchIndex: 0, //当前是点击了哪一个搜索框
				treeSelectData: [],
				inputSelectApi: "", //自动补全内容搜索接口
				inputSelectValueKey: "",//需要返回接口返回数据参数名称
				inputSelectLabelKey: "",//需要显示接口返回数据参数名称
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
        isShowList:false,
       /* dyOrderIndex: 0,
        customInfoIndex: 0,
        myOrderIndex: 0,
        refundStatusIndex: 0,*/
        dyOrderValue: '',
        customInfoValue: '',
        myOrderValue: '',
        refundStatusValue: '',
        searchInputData: {},
			}
		},
		methods: {
			/**
			 * 搜索按钮点击事件
			 */
			searchBtnClick(evt) {
        let target = evt.target;
        if(target.nodeName == "SPAN"){
          target = evt.target.parentNode;
        }
        target.blur();
				console.log(this.searchData);
				let that = this;
				// let searchInputData = {};
				if (that.searchData.length > 0) {
					that.searchData.forEach((item, index) => {
						if(item.type == 'cascader'){
							if(item.valuesKey){
								if(item.value){
									item.valuesKey.forEach((keyItem,keyIndex)=>{
                    that.searchInputData[keyItem] = item.value[keyIndex] || ''
									})
								}else{
									item.valuesKey.forEach((keyItem,keyIndex)=>{
                    that.searchInputData[keyItem] = ''
									})
								}
							}
						}else{
							if(typeof item.value == 'string'){
                that.searchInputData[item.name] = this.$utils.trim(item.value,'g');
							}else{
                that.searchInputData[item.name] = item.value;
							}
						}
						
					})
				}
        that.searchInputData.orderStatus = this.dyOrderValue;
        that.searchInputData.makeStatus = this.customInfoValue;
        that.searchInputData.myOrderStatus = this.myOrderValue;
        that.searchInputData.refundStatus = this.refundStatusValue;
				this.$emit("searchClick", that.searchInputData);
			},
      /**
       * 重置
       */
      resetBtnClick(evt){
        let target = evt.target;
        if(target.nodeName == "SPAN"){
          target = evt.target.parentNode;
        }
        target.blur();
        let that = this;
        that.searchData[0].value = '';
        that.searchData[1].value = '';
        that.searchData[2].value = '';
        that.searchData[3].value = '';
        that.searchData[4].value = '';
        that.searchData[5].value = '';
        that.searchData[6].value = '1';
/*        that.dyOrderIndex = 0;
        that.customInfoIndex = 0;
        that.myOrderIndex = 0;
        that.refundStatusIndex = 0;*/
        this.$emit('update-count', 0,'dyOrderIndex');
        this.$emit('update-count', 0,'customInfoIndex');
        this.$emit('update-count', 0,'myOrderIndex');
        this.$emit('update-count', 0,'refundStatusIndex');
        that.dyOrderValue = '';
        that.customInfoValue = '';
        that.myOrderValue = '';
        that.refundStatusValue = '';
        that.searchInputData = {
          pageNo:1,
          pageSize:10,
          addTime:[],
          douYinProName:'',
          orderSId:'',
          orderType:'',
          orderChannel:1,
          orderStatus:'',
          makeStatus:'',
          myOrderStatus:'',
          searchParam:'',
          manageUserId:'',
          refundStatus:'',
          myOrderNo:'',
        }
        this.$emit("resetClick", this.searchInputData);
      },
      /**
       * 点击选择树
       */
      exportClick(){
        this.$emit("exportClick", this.searchInputData);
      },
			/**
			 * 点击选择树
			 */
			searchTree(index) {
				this.clickSearchIndex = index;
				this.treeApi = this.searchData[index].treeApi;
				this.treeApiParam = this.searchData[index].treeApiParam;
				this.selectType = this.searchData[index].selectType || 'checkbox';
				this.dialogTitle = this.searchData[index].dialogTitle || '菜单';
				this.treeNodeKey = this.searchData[index].treeNodeKey || 'key';
				this.treeProps = this.searchData[index].treeProps || {
					label: 'title',
					children: 'children',
					isLeaf: 'leaf'
				};
				this.treeLazy = this.searchData[index].treeLazy || false;
				if (!this.treeLazy) {
					this.getTreeData();
				}
				this.isShowTreeDialog = true;
			},
			/**
			 * 初始化树数据
			 */
			getTreeData() {
				this.$http.post(this.treeApi, this.treeApiParam).then(res => {
					if (res.code == 200) {
						this.treeData = res.data;
					}
				})
			},
			/**
			 * input清除选择树信息
			 */
			clearSearchTree(index) {
				this.searchData[index].valueText = '';
				this.searchData[index].value = '';
			},
			/**
			 * 加载树数据
			 */
			loadTreeNode(node, resolve) {
				console.log(node)
				let key = node.level > 0 ? node.data[this.treeNodeKey] : '';
				this.$http.post(this.treeApi, {
					parentId: key
				}).then(res => {
					if (res.code == 200) {
						res.data.forEach(item => {
							if (this.$utils.isEmpty(item[this.treeProps.children])) {
								item.leaf = true;
							}
						})
						resolve(res.data)
					}
				})
			},
			/**
			 * 选择树弹框点击确认
			 */
			treeDialogConfirm() {
				let val = [];
				let valTex = [];
				if (this.selectType == 'checkbox') {
					this.treeSelectData = this.$refs.dialogTree.getCheckedNodes()
				} else {
					this.treeSelectData = this.$refs.dialogTree.getCurrentNode();
				}
				if (this.$utils.isEmpty(this.treeSelectData)) {
					this.$message('请选择节点')
					return
				}
				if (this.selectType == 'checkbox') {
					this.treeSelectData.forEach(item => {
						val.push(item[this.treeNodeKey])
						valTex.push(item[this.treeProps.label])
					})
					this.searchData[this.clickSearchIndex].value = val;
					this.searchData[this.clickSearchIndex].valueText = valTex.join();
				} else {
					this.searchData[this.clickSearchIndex].value = this.treeSelectData[this.treeNodeKey];
					this.searchData[this.clickSearchIndex].valueText = this.treeSelectData[this.treeProps.label];
				}

				this.isShowTreeDialog = false;
			},
			/**
			 * 选择树弹框关闭
			 */
			treeDialogClose() {
				this.isShowTreeDialog = false;
			},
			/**
			 * 下拉列表切换事件
			 * @param {Object} e
			 */
			changeSelect(e, name) {

        this.searchInputData.orderStatus = this.dyOrderValue;
        this.searchInputData.makeStatus = this.customInfoValue;
        this.searchInputData.myOrderStatus = this.myOrderValue;
        this.searchInputData.refundStatus = this.refundStatusValue;
        if(name == "status"){
          this.searchInputData.orderChannel = e;
        }else {
          this.searchInputData.manageUserId = e;
        }

				this.$emit("changeSelect", e, name,this.searchInputData);
			},
			/**
			 * 级联选中切换事件
			 * @param {Object} e
			 */
			changeCascaderSelect(e) {
				this.$emit("changeCascaderSelect", e);
			},
			/**
			 * 输入内容自动查询搜索结果输入框 获取焦点事件
			 * @param {Object} childType
			 */
			getInputSelectType(e) {
				console.log("childType:::", e.target.dataset);
				this.inputSelectApi = e.target.dataset.api;
				this.inputSelectValueKey = e.target.dataset.valuekey;
				this.inputSelectLabelKey = e.target.dataset.labelkey;
			},
			/**
			 * 输入内容自动查询搜索结果输入框
			 * @param {Object} queryStr
			 * @param {Object} callback
			 */
			querySearch(queryStr, callback) {
				let that = this;
				let result = [];
				let param = {};
				console.log(queryStr)
				// param[]
				that.$http.post(that.inputSelectApi, {
					"keyword": queryStr
				}).then(res => {
					if (res.code == 200) {
						if(!this.$utils.isEmpty(res.data)){
							res.data.forEach(item=>{
								result.push({
									value: item[this.inputSelectValueKey],
									label: item[this.inputSelectLabelKey],
								});
								callback(result);
							})
						}else{
							callback([]);
						}
						
					}
				})
			},
			/**
			 * 选择上搜索项
			 */
			handleInputSelect(index,e){
			  this.searchData[index].value = e.value || ''
			},
			/**
			 * 清空搜索项
			 */
			clearAutocomplete(index){
				this.searchData[index].value = '';
			},
			/**
			 * 时间选择切换事件
			 * @param {Object} e
			 */
			changeDateTimeRange(e) {
				this.$emit("changeDateTimeRange", e);
			},
      /**
       * 展开、收起列表
       * @param {Object} e
       */
      cutList(e){
        console.log(e)
        console.log(this.searchList)
        this.isShowList = !e;
      },
      /**
       * 筛选列表
       * @param {Object} e
       */
      dyOrderClick(index, value){
        this.dyOrderValue = value;
        this.searchInputData.orderStatus = this.dyOrderValue;
        this.searchInputData.makeStatus = this.customInfoValue;
        this.searchInputData.myOrderStatus = this.myOrderValue;
        this.searchInputData.refundStatus = this.refundStatusValue;
        this.$emit("dyOrderClick", this.searchInputData);
        this.$emit('update-count', index,'dyOrderIndex');
      },
      /**
       * 筛选列表
       * @param {Object} e
       */
      customInfoClick(index, value){
        // this.customInfoIndex = index;
        this.customInfoValue = value;
        this.searchInputData.orderStatus = this.dyOrderValue;
        this.searchInputData.makeStatus = this.customInfoValue;
        this.searchInputData.myOrderStatus = this.myOrderValue;
        this.searchInputData.refundStatus = this.refundStatusValue;
        this.$emit("customInfoClick", this.searchInputData);
        this.$emit('update-count', index,'customInfoIndex');
      },
      /**
       * 筛选列表
       * @param {Object} e
       */
      myOrderClick(index, value){
        // this.myOrderIndex = index;
        this.myOrderValue = value;
        this.searchInputData.orderStatus = this.dyOrderValue;
        this.searchInputData.makeStatus = this.customInfoValue;
        this.searchInputData.myOrderStatus = this.myOrderValue;
        this.searchInputData.refundStatus = this.refundStatusValue;
        this.$emit("myOrderClick", this.searchInputData);
        this.$emit('update-count', index,'myOrderIndex');
      },
      /**
       * 筛选列表
       * @param {Object} e
       */
      refundStatusClick(index, value){
        // this.refundStatusIndex = index;
        this.refundStatusValue = value;
        this.searchInputData.orderStatus = this.dyOrderValue;
        this.searchInputData.makeStatus = this.customInfoValue;
        this.searchInputData.myOrderStatus = this.myOrderValue;
        this.searchInputData.refundStatus = this.refundStatusValue;
        this.$emit("myOrderClick", this.searchInputData);
        this.$emit('update-count', index,'refundStatusIndex');
      },
		},
	}
</script>

<style scoped>
	.container {
		height: auto;
		overflow: auto;
		overflow-y: hidden;
	}

	.searchItemTitle {
		line-height: 20px;
		font-size: 14px;
		color: #5C7085;
		margin-bottom: 4px;

	}

	.searchItemDiv {
		margin-right: 40px;
		margin-bottom: 5px;
        margin-top: 15px;
	}

	.searchBtn {
		margin-top: 30px;
	}
	.searchBtn .el-button{
        height: 30px;
        font-size: 12px;
    }
	.searchBtn img{
		width: 30px;
		margin-left: 23px;
	}

	.icon_search_white {
		width: 12px;
		margin-right: 5px;
	}

	.dialogForm .el-tree {
		min-width: 80px;
	}
</style>
<style>
	.searchItemInput .el-input__wrapper,
	.searchItemCascader .el-input__wrapper {
		padding: 0 10px 0 0 !important;
		width: 180px !important;
		height: 30px !important;
	}

	.searchItemCascader .el-input__wrapper {
		width: 220px !important;
	}

	.searchItemInput .el-input__inner,
	.searchItemCascader .el-input__inner {
		width: 100%;
		height: 100%;
		padding: 0 8px !important;
		font-size: 12px;
	}

	.searchItemDiv .el-range-editor.el-input__wrapper {
		padding: 0 8px !important;
		box-sizing: border-box;
	}

	.searchItemDiv .el-checkbox {
		margin-top: 27px;
	}

	.elFormTree .el-form-item {
		display: flex;
		align-items: flex-start;
	}
  .selectList{
    width: 100%;
    margin-top: 24px;
  }
  .dyOrderStatusDiv {
    margin-bottom: 12px;
  }
  .dyOrderStatusDiv span{
    line-height: 30px;
    font-size: 14px;
    color: #5C7085;
    float: left;
    /*font-weight: bold;*/
  }
  .dyOrderStatusDiv ul{
    float: left;
    padding: 0;
    margin: 0;
  }
  .dyOrderStatusList li.active{
    background: rgba(74,127,248,0.2);
    color: #4A7FF8;
    border-radius: 4px;
  }
  .dyOrderStatusDiv ul li{
    list-style-type: none;
    min-width: 45px;
    height: 28px;
    line-height: 30px;
    text-align: center;
    font-size: 12px;
    color: #555;
    margin-left: 18px;
    float: left;
    padding: 0 10px;
    cursor: pointer;
  }
  .searchItemDiv .el-range-editor.el-input__wrapper{
    height: 30px;
  }
  .el-select-dropdown__item{
    font-size: 12px;
  }
</style>
